import axios from 'axios'

export default axios.create({
    baseURL: 'https://lineapi.lpn.co.th/api/authen'
})
